import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SecureApi } from '../../core/secure.api';

@Injectable()
export class MeDynamicReportService {
    constructor(
        public http: HttpClient,
        public secureApi: SecureApi,
        public translate: TranslateService, 
        @Inject('storyBlokToken') public storyBlokToken: string,
    ) {
    }

    getDynamicReport() {
        return this.secureApi.get('b2c-patients/dynamic-report/patient/' + this.translate.currentLang);
    }

    getDynamicReportCluster(id) {
        return this.secureApi.get('b2c-patients/dynamic-report/patient/active-cluster/' + id + '/' + this.translate.currentLang);
    }

    getDynamicReportRating() {
        return this.secureApi.get('b2c-patients/dynamic-report/patient-rating');
    }

    getSpeech(text) {
        let data = {
            text: text,
            lang: this.translate.currentLang
        };

        return this.secureApi.post('get-speech', data, false);
    }
}
